module.exports = __webpack_public_path__ + "img/download_and.541bc97f.png";